import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import submit from './submit';
import validate from './validate';

import cx from 'classnames';
import {
  Button,
  Row,
  FormGroup,
  Col,
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './WhyHostFormBlock2.css';
import cs from '../../../../components/commonStyle.css';
import CommonFormComponent from '../../../CommonField/CommonFormComponent';
import MultiLanguageInput from '../../MultiLanguageInput/MultiLanguageInput';

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../../../locale/messages';

class WhyHostFormBlock2 extends Component {
  constructor(props) {
    super(props);
    this.handleFieldChange = this.handleFieldChange.bind(this);
  }

  handleFieldChange(fieldName, value) {
    const { dispatch } = this.props;
    dispatch(change('WhyHostForm', fieldName, value));
  }

  render() {
    const { error, handleSubmit, submitting, dispatch, formValues } = this.props;
    const { formatMessage } = this.props.intl;

    // Hidden fields to register multilingual fields with Redux Form
    const multilingualFields = ['earnBlockTitle1', 'earnBlockContent1'];
    const langSuffixes = ['_en', '_fr', '_it', '_pt'];
    const hiddenFields = [];
    multilingualFields.forEach(base => {
      langSuffixes.forEach(suffix => {
        hiddenFields.push(
          <Field key={`${base}${suffix}`} name={`${base}${suffix}`} component="input" type="hidden" />
        );
      });
    });

    return (
      <div className={cx(cs.adminContentPadding)}>
        <div className={s.sectionCenter}>
          <div className={cs.commonAdminBorderSection}>
          <h1 className={s.headerTitle}><FormattedMessage {...messages.WhyBecomeOwnerBlock2} /></h1>
              <form onSubmit={handleSubmit((values) => {
                const payload = { ...values, ...formValues };
                console.log('🚀 [WhyHostFormBlock2] Sending:', payload);
                return submit(payload, dispatch);
              })}>
                {hiddenFields}
                {error && <strong>{formatMessage(error)}</strong>}
                <FormGroup className={s.space3}>
                  <label className={cs.labelTextNew}><FormattedMessage {...messages.earnBlockTitle} /></label>
                  <MultiLanguageInput
                    baseField="earnBlockTitle1"
                    inputType="text"
                    values={formValues}
                    onChange={this.handleFieldChange}
                  />
                </FormGroup>
                <FormGroup className={s.space3}>
                  <label className={cs.labelTextNew}><FormattedMessage {...messages.earnBlockContent} /></label>
                  <MultiLanguageInput
                    baseField="earnBlockContent1"
                    inputType="textarea"
                    values={formValues}
                    onChange={this.handleFieldChange}
                  />
                </FormGroup>
                <FormGroup className={s.noMargin}>
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={12} className={cx(cs.textAlignRight, 'textAlignLeftRTL')}>
                      <Button className={cx(cs.btnPrimary, cs.btnlarge)} type="submit" disabled={submitting}>
                        <FormattedMessage {...messages.save} />
                      </Button>
                    </Col>
                  </Row>
                </FormGroup>
              </form>
          </div>
        </div>
      </div>
    );
  }
}

WhyHostFormBlock2 = reduxForm({
  form: 'WhyHostForm',
  validate,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false
})(WhyHostFormBlock2);

const selector = formValueSelector('WhyHostForm');
const textFields = ['earnBlockTitle1', 'earnBlockContent1'];
const languages = ['', '_en', '_fr', '_it', '_pt'];

const mapState = (state) => {
  const formValues = {};
  textFields.forEach(field => {
    languages.forEach(lang => {
      formValues[`${field}${lang}`] = selector(state, `${field}${lang}`);
    });
  });
  return { formValues };
};

export default injectIntl(withStyles(s, cs)(connect(mapState)(WhyHostFormBlock2)));